<template>
    <div class="operations-configuration-container">
        <ToastsContainer />
        <SidebarComponent />
        <div class="operations-configuration-content">
            <h1>Operations Configuration</h1>
            <section class="operations-config">
                <section class="config-card">
                    <h2>Backlog Insights</h2>
                    <ConfigurationGridComponent
                        title="Age Bands"
                        :data-ref="backlog.configurationData"
                        :on-edit="() => {}"
                        :on-save="backlog.updateConfiguration"
                        :on-cancel="() => {}"
                        :on-reset-to-defaults="backlog.resetConfiguration"
                    />
                </section>
                <section class="config-card">
                    <h2>Assignments Insights</h2>
                    <ConfigurationGridComponent
                        title="Age Bands"
                        :data-ref="assignments.configurationData"
                        :on-edit="() => {}"
                        :on-save="assignments.updateConfiguration"
                        :on-cancel="() => {}"
                        :on-reset-to-defaults="assignments.resetConfiguration"
                    />
                    <StatusMappingComponent />
                </section>
            </section>
        </div>
    </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { ToastsContainer } from '@/components';
import { useBacklogInsightsConfiguration } from '@/composables/useBacklogInsightsConfiguration';
import { useAssignmentsConfiguration } from '@/composables/useAssignmentsConfiguration';
import ConfigurationGridComponent from '@/components/OperationsConfigurationPage/ConfigurationGridComponent.vue';
import StatusMappingComponent from '../StatusMapping/StatusMappingComponent.vue';

const backlog = useBacklogInsightsConfiguration();
const assignments = useAssignmentsConfiguration();

onMounted(() => {
    backlog.fetchConfiguration();
    assignments.fetchConfiguration();
});
</script>

<style lang="scss" scoped>
.operations-configuration-container {
    display: flex;
    height: 100vh;
}

.operations-configuration-content {
    flex: 1;
    padding: 2rem;
}

.operations-config {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.config-card {
  position: relative;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
}
</style>